export default "__VITE_ASSET__D66nHKca__"